import React from 'react'

import clsx from 'clsx'
import Masonry from 'react-masonry-css'

import AuthorCard from 'components/AuthorCard'
import Icon from 'components/Icon'
import useViewport from 'hooks/useViewport'

import classes from './Authors.module.scss'

/** @type {import("./types").default} */
const Authors = ({ authors }) => {
  const { is } = useViewport()

  const masonryDefaultColumns = is('xs') ? 1 : 2

  const renderAuthors = () => {
    if (authors.items.length === 1) {
      return <AuthorCard className="Authors" author={authors.items[0]} hasLink tipText="About the author" />
    }
    return (
      <Masonry
        className={classes.masonry}
        columnClassName={classes.column}
        breakpointCols={{
          default: masonryDefaultColumns,
          959: 1,
        }}
      >
        {authors.items.map(author => (
          <AuthorCard key={`author-${author.authorName}`} author={author} hasLink tipText="About the author" />
        ))}
      </Masonry>
    )
  }

  if (!authors?.items?.length) {
    return null
  }

  return (
    <div className={clsx('Authors', classes.root)}>
      {renderAuthors()}
      <div className={classes.spacerContainer}>
        <Icon icon="logo-square" prefix="ga" size={32} className={classes.spacer} />
      </div>
    </div>
  )
}

export default Authors
